export default {
    createPlace: 'Create Place',
    updatePlace: 'Edit Place',
    namePlace: 'Name Place',
    latitude: 'Latitude',
    longitude: 'Longitude',
    radian: 'Radian (Meter)',
    thisFieldIsRequired: 'This field is required',
    thisFieldIsExceededCharacters: 'This field is exceeded 255 characters',
    save: 'Save',
    congratulation: 'Congratulation',
    placeIsUpdated: 'Place is updated',
    placeIsCreated: 'Place is created'
}
